import React from 'react';
import { LeaveRequest } from '../../../../api/RequestApi';
import { BaseRequestItem } from '../BaseRequestItem';
import { useTranslation } from 'react-i18next';
import { Button } from "../../../../components/Button";

interface MyLeaveRequestItemProps {
    request: LeaveRequest;
    onCancel: (request: LeaveRequest) => Promise<void>;
    onEdit?: (request: LeaveRequest) => void;
    loading?: boolean;
}

export function MyLeaveRequestItem({
                                       request,
                                       onCancel,
                                       onEdit,
                                       loading = false
                                   }: MyLeaveRequestItemProps) {

    const { t, i18n } = useTranslation();
    const locale = i18n.language === 'de' ? 'de-DE' : 'en-US';

    const startDate = request.leaveStart ? new Date(request.leaveStart).toLocaleDateString(locale) : '';
    const endDate = request.leaveEnd ? new Date(request.leaveEnd).toLocaleDateString(locale) : '';

    const handleCancel = () => {
        onCancel(request);
    };

    return (
        <BaseRequestItem
            requestId={request.id}
            title={t(`leaveRequest.absenceType.${request.leaveType.name}`, {
                defaultValue: t('leaveRequest.title')
            })}
            description={request.description}
            actions={
                <>
                    {request.editable && onEdit && (
                        <Button
                            variant="outlined"
                            onClick={() => onEdit(request)}
                            isDisabled={loading}
                        >
                            {t('leaveRequest.action.edit')}
                        </Button>
                    )}

                    {request.cancellable && (
                        <Button
                            variant="contained"
                            color="attention"
                            loading={loading}
                            isDisabled={!request.cancellable}
                            onClick={handleCancel}
                        >
                            {t('leaveRequest.action.cancel')}
                        </Button>
                    )}
                </>
            }
        >
            <div className="mt-1 text-sm text-gray-500">
                {startDate} - {endDate}, {request.leaveDays} {t('leaveRequest.days')}
            </div>
            <div className="mt-1 text-sm font text-gray-500">
                {t(`leaveRequest.status.${request.state.toLowerCase()}`, {
                    defaultValue: request.state
                })}
            </div>
        </BaseRequestItem>
    );
}